/**
 * 価格種別ラベルの判定ロジック（価格表の表示とCSV出力で共有）。
 * 施設が暫定期間、または取引が暫定価の場合は「参考価格」、妥結後は「妥結価」。
 */
export const resolvePriceTypeLabel = (
  facilityStatus: string,
  priceType: string | null | undefined
): '参考価格' | '妥結価' =>
  facilityStatus === '暫定' || priceType === '暫定価' ? '参考価格' : '妥結価';
